import i18n from './i18n';
import {
  feVersionSlots,
  hasDistinctFeVersions,
  headlineDriftState,
  prodReleaseId,
  sameReleaseId,
  type CodableCarousel,
  type CodableDriftKind,
} from './codable-drift-state';

export type { CodableCarousel, CodableDriftKind };
export {
  feVersionSlots,
  hasDistinctFeVersions,
  headlineDriftState,
  prodReleaseId,
  sameReleaseId,
};

export type CodableDriftLevel = 'ok' | 'warn' | 'danger';

export interface CodableDriftStatus {
  relation?: { states?: string[]; warnings?: string[] };
  dev?: {
    short_head?: string | null;
    dirty?: boolean;
    changed_files?: number;
    /** Commity, které workspace má a GitLab ne — nabídka „zarovnat na Git". */
    ahead?: number | null;
  };
  prod?: { short_head?: string | null };
  carousel?: CodableCarousel | null;
  topology?: {
    split?: boolean;
    target?: string | null;
    actual?: string | null;
  } | null;
}

export function driftSeverity(
  status?: CodableDriftStatus | null,
): CodableDriftLevel {
  const kind = headlineDriftState(status?.relation?.states ?? []);
  if (kind === 'prod_ahead') return 'danger';
  if (kind) return 'warn';
  return 'ok';
}

export function driftSummary(status?: CodableDriftStatus | null): string {
  const kind = headlineDriftState(status?.relation?.states ?? []);
  if (kind === 'prod_ahead') return i18n.t('codable.wsDriftProdAhead');
  if (kind === 'dev_behind') return i18n.t('codable.wsDriftGitNewer');
  if (kind === 'prod_behind') return i18n.t('codable.wsDriftProdBehind');
  if (kind === 'dev_dirty') return i18n.t('codable.wsDriftDevDirty');
  if (kind === 'preview_waiting') return i18n.t('codable.wsDriftPreviewWaiting');
  if (kind === 'git_fetch') return i18n.t('codable.wsDriftGitRemote');
  return i18n.t('codable.wsDriftClean');
}


